import { container } from "tsyringe";
export class UseCaseGetClientIp {
    async handle() {
        const getClientIp = container.resolve("iGetClientIp");
        const clientIp = await getClientIp.handle();
        return clientIp;
    }
}
